import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TestService } from '../../../services/TestService';

export const TestMailPrimerVencimiento = () => {
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        await TestService.testMailPrimerVencimiento();
      } finally {
        navigate('/bandejaTrabajo', { replace: true });
      }
    })();
  }, [navigate]);
  return null;
};

export const TestMailSegundoVencimiento = () => {
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        await TestService.testMailSegundoVencimiento();
      } finally {
        navigate('/bandejaTrabajo', { replace: true });
      }
    })();
  }, [navigate]);
  return null;
};

export const TestMailDocumentoVencidoArea = () => {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        await TestService.testMailDocumentoVencidoArea();
      } finally {
        navigate('/bandejaTrabajo', { replace: true });
      }
    })();
  }, [navigate]);

  return null;
};